var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import gql from 'graphql-tag';
export var initialState = {
    errorDialog: false,
    errorCode: '',
    errorMessage: '',
};
export var localResolvers = {};
export var localDataQuery = function () { return ({
    query: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    query {\n      errorDialog @client\n      errorCode @client\n      errorMessage @client\n    }\n  "], ["\n    query {\n      errorDialog @client\n      errorCode @client\n      errorMessage @client\n    }\n  "]))),
}); };
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/gql/localData.ts
// module id = 624
// module chunks = 81